// libs
import React from "react";
// dashboard
import StatisticsIcon from "./StatisticsIcon";
// profile
import WorkShiftIcon from "./WorkShiftIcon";
// daily report
import MyDailyReportIcon from "./MyDailyReportIcon";
import AllDailyReportIcon from "./AllDailyReportIcon";
// setting
import SettingIcon from "./SettingIcon";
import NewDashBoardIcon from "./NewDashBoardIcon";
import NewAttendanceIcon from "./NewAttendanceIcon";
import NewCalendarIcon from "./NewCalendarIcon";
import NewProfileIcon from "./NewProfileIcon";
import NewDailyReportTemplateIcon from "./NewDailyReportTemplateIcon";

export const HrsolIcons = {
  // dashboard
  DashboardIcon: <NewDashBoardIcon style={{ fontSize: "1.8em" }} />,
  StatisticsIcon: <StatisticsIcon />,
  // attendance
  AttendanceIcon: <NewAttendanceIcon style={{ fontSize: "1.8em" }} />,
  // calendar
  CalendarIcon: <NewCalendarIcon style={{ fontSize: "1.8em" }} />,
  // profile
  ProfileIcon: <NewProfileIcon style={{ fontSize: "1.8em" }} />,
  WorkShiftIcon: <WorkShiftIcon />,
  // daily report
  DailyReportIcon: <NewDailyReportTemplateIcon style={{ fontSize: "1.8em" }} />,
  MyDailyReportIcon: <MyDailyReportIcon />,
  AllDailyReportIcon: <AllDailyReportIcon />,
  // setting
  SettingIcon: <SettingIcon />,
};
